import React from 'react';
import styles from './DrawerPage.module.css';

function SidebarPageItem({ title, icon, onClick, selected }) {
  return (
    <button
      className={selected ? styles.sidebarItemSelected : styles.sidebarItem}
      onClick={onClick}
    >
      {icon}
      {title}
    </button>
  );
}

export default SidebarPageItem;
